export const PlayCircleIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3177_140)">
      <path
        d="M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6818 1.33337 7.99992 1.33337C4.31802 1.33337 1.33325 4.31814 1.33325 8.00004C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z"
        stroke="#B54708"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <path
        d="M6.33325 5.97693C6.33325 5.65874 6.33325 5.49964 6.39975 5.41083C6.45769 5.33342 6.54639 5.285 6.64284 5.27811C6.75351 5.27021 6.88733 5.35624 7.15499 5.5283L10.3021 7.55141C10.5343 7.70072 10.6504 7.77537 10.6905 7.8703C10.7256 7.95324 10.7256 8.04684 10.6905 8.12978C10.6504 8.22471 10.5343 8.29936 10.3021 8.44867L7.15499 10.4718C6.88734 10.6438 6.75351 10.7299 6.64284 10.722C6.54639 10.7151 6.45769 10.6667 6.39975 10.5893C6.33325 10.5004 6.33325 10.3413 6.33325 10.0232V5.97693Z"
        stroke="#B54708"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </g>
    <defs>
      <clipPath id="clip0_3177_140">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
